module.exports = __webpack_public_path__ + "img/bg_seaside.d3174131.jpg";